import { __decorate } from "tslib";
import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
// import DetailsLeftToolbar from '@blade/common/pages/result-details/components/details-left-toolbar.vue';
import DetailsLeftToolbar from '@blade/common/pages/alert-details/components/details-left-top.vue';
import DetailsLeftPicture from '@blade/common/pages/result-details/components/details-left-picture.vue';
import DetailsLeftBottom from '@blade/common/pages/result-details/components/details-left-bottom.vue';
import { fromPage } from '@blade/common/interfaces/result-details';
import { getTaskTargetStr } from '@blade/common/pages/result-details/common/util';
import { getSearchQueryAttributesSearch } from '@blade-sxp/task-management/api/task-result/index';
import { spaceTimeType } from '@blade/common/pages/result-details/common/config';
import { AlarmCenterModule } from '@blade-sxp/alarm-center/store/index';
import moment from 'moment';
import { downImage } from '@blade/common/utils/down-image';
let Details = class Details extends Vue {
    filterImgLv;
    detailsType;
    detailsRoute;
    isDetailsLeftBottomProps;
    detailsData;
    offset;
    pictureRef;
    imageScreenRef;
    toolbarRef;
    isChartType;
    onDetailsData() {
        this.details = this.detailsData;
        AlarmCenterModule.updateDetailsData(this.details);
        this.initSrcData();
        this.imageDetect = [];
        // this.$nextTick(() => {
        //   (this.$refs.toolbarRef as HTMLFormElement).changeLayerVal();
        // });
    }
    oniIDetailsLeftBottom() {
        this.isDetailsLeftBottom = this.isDetailsLeftBottomProps;
    }
    fullScreenImgFlag = false;
    routePage = fromPage.EVENT_PAGE;
    layerVal = true;
    indexImg = 0;
    isDetailsLeftBottom = false;
    srcList = [];
    captureUrlList = [];
    details = {};
    capturePerson = [];
    toggleLoading = false;
    imageDetect = [];
    downImage = downImage;
    get imgSrc() {
        console.log('this.srcList[this.indexImg]', this.srcList, this.srcList[this.indexImg]);
        return this.srcList[this.indexImg];
    }
    mounted() {
        this.details = this.detailsData;
        AlarmCenterModule.updateDetailsData(this.details);
        this.initSrcData();
    }
    // 添加脑图子节点
    addChart(e) {
        this.$emit('addChart', this.capturePerson[e - 1]);
    }
    // 添加脑图子节点
    addChartDetect(val) {
        this.$emit('addChartDetect', val);
    }
    imageDetectFunc(data) {
        this.imageDetect = [...data];
    }
    downImg() {
        const url = this.srcList[this.indexImg];
        this.downImage(url);
    }
    changeSwitch(val) {
        this.layerVal = val;
    }
    initSrcData() {
        this.srcList = [];
        this.captureUrlList = [];
        const type = getTaskTargetStr('incidentType', 'type', this.detailsType);
        if (type === 'Face') {
            if (this.detailsRoute === fromPage.EVENT_PAGE) {
                if (this.details.incidentRecordVO) {
                    // 区分是人脸，还是人体
                    if (this.details.incidentRecordVO.incidentType === 'FACE_MATCH' ||
                        this.details.incidentRecordVO.incidentType === 'INCIDENT_FACE_UNMATCHED') {
                        this.srcList.push(this.details.incidentRecordVO.faceAnnotation.panoramicImage);
                        this.captureUrlList.push(this.details.incidentRecordVO.faceAnnotation.portraitCaptureImage);
                    }
                    if (this.details.incidentRecordVO.incidentType === 'FACE_PEDESTRIAN') {
                        this.srcList.push(this.details.incidentRecordVO.pedestrianAnnotation.panoramicImage);
                        this.captureUrlList.push(this.details.incidentRecordVO.pedestrianAnnotation.portraitCaptureImage);
                    }
                }
                else {
                    this.getCapturePersonPic();
                }
            }
            if (this.detailsRoute === fromPage.FILECLUSTER_PAGE || this.detailsRoute === fromPage.BIGDATA_PAGE) {
                this.captureUrlList.push(this.details.captureImage);
                this.srcList.push(this.details.panoramicImage);
            }
            if (this.detailsRoute === fromPage.TIME_PAGE || this.detailsRoute === fromPage.FEATURES_PAGE) {
                this.getCapturePersonPic();
            }
            if (this.detailsRoute === fromPage.TASK_PAGE) {
                if (this.details.isDetailsType) {
                    // 告警
                    // 区分是人脸，还是人体
                    if (this.details.incidentType === 'FACE_MATCH' || this.details.incidentType === 'INCIDENT_FACE_UNMATCHED') {
                        this.srcList.push(this.details.faceAnnotation.panoramicImage);
                        this.captureUrlList.push(this.details.faceAnnotation.portraitCaptureImage);
                    }
                    if (this.details.incidentType === 'FACE_PEDESTRIAN') {
                        this.srcList.push(this.details.pedestrianAnnotation.panoramicImage);
                        this.captureUrlList.push(this.details.pedestrianAnnotation.portraitCaptureImage);
                    }
                }
                else {
                    // 解析
                    this.getCapturePersonPic();
                }
            }
        }
        else if (type === 'Automobile' || type === 'MotorBike') {
            this.getCapturePersonPic();
        }
        else {
            if (this.detailsType === 'OBJECT_EVERYTHING' || this.detailsType === 'OBJECT_ALGO') {
                this.srcList.push(this.details.panoramicUrl);
            }
            this.srcList.push(this.details.captureUrl);
        }
        if (this.isDetailsLeftBottomProps) {
            this.getTaskDetail();
        }
    }
    // 同行人图片获取
    getCapturePersonPic() {
        this.srcList.push(this.details.panoramicUrl);
        this.captureUrlList.push(this.details.captureUrl);
    }
    // 同行人员查询
    getTaskDetail() {
        if (this.toggleLoading)
            return;
        let time = moment(this.details.captureTime).valueOf();
        const featureList = {
            featureType: '',
            taskType: '',
        };
        if (spaceTimeType.includes(this.detailsType)) {
            featureList.featureType = this.detailsType;
        }
        else {
            if (this.detailsRoute === fromPage.EVENT_PAGE) {
                featureList.taskType = this.details.incidentRecordVO.taskConsist.taskType;
            }
            else if (this.detailsRoute === fromPage.TASK_PAGE) {
                featureList.taskType = this.details.taskConsist.taskType;
            }
            else {
                featureList.taskType = this.detailsType;
            }
        }
        const data = {
            dateEnd: moment(Number(time) + 5000).format('YYYY-MM-DD HH:mm:ss'),
            dateStart: moment(Number(time) - 5000).format('YYYY-MM-DD HH:mm:ss'),
            deviceIdList: this.details.deviceId ? [this.details.deviceId] : null,
            featureList: [featureList],
            size: 100,
        };
        this.capturePerson = [];
        this.$emit('toggle-loading', true);
        this.toggleLoading = true;
        getSearchQueryAttributesSearch(data)
            .then((res) => {
            if (res) {
                let trackIdArr = [];
                if (res.searchList) {
                    res.searchList[0]?.list.forEach((d) => {
                        // 去掉重复的，根据panoramicUrl去除掉和目标对象一样的图片
                        if (d.panoramicUrl && d.captureUrl && d.panoramicUrl !== this.srcList[0]) {
                            if (d.trackId && !trackIdArr.includes(d.trackId)) {
                                trackIdArr.push(d.trackId);
                                this.srcList.push(d.panoramicUrl);
                                this.captureUrlList.push(d.captureUrl);
                                this.capturePerson.push(d);
                            }
                        }
                        // 同行人数据，根据trackId，去除掉相同的人
                    });
                }
                this.$emit('toggle-loading', false);
                this.toggleLoading = false;
            }
        })
            .catch((err) => {
            this.$emit('toggle-loading', false);
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
    isValidKey(key, object) {
        return key in object;
    }
    onFullScreen(type) {
        if (type === 2) {
            this.fullScreenImgFlag = false;
        }
        else {
            this.fullScreenImgFlag = true;
        }
        this.imageScreenRef.clickHandler();
        const filterClassName = ['-webkit-filter', '-moz-filter', '-ms-filter', 'filter'];
        this.$nextTick(() => {
            filterClassName.forEach((item) => {
                if (this.isValidKey(item, filterClassName)) {
                    document.getElementsByClassName('el-image-viewer__canvas')[0].style[item] = `blur(${this.filterImgLv}px)`;
                }
            });
        });
    }
    getCaptureUrl(url) {
        if (url === 'panoramic') {
            return this.srcList[this.indexImg];
        }
        return this.captureUrlList[0];
    }
    zoomReset() {
        this.$refs.pictureRef.zoomReset();
    }
    zoomOut() {
        this.$refs.pictureRef.zoomOut();
    }
    zoomIn() {
        this.$refs.pictureRef.zoomIn();
    }
    changeImgIndex(e) {
        this.imageDetect = [];
        this.indexImg = e;
        if (e === 0) {
            this.details = this.detailsData;
            AlarmCenterModule.updateDetailsData(this.details);
        }
        else {
            this.details = this.capturePerson[e - 1];
            AlarmCenterModule.updateDetailsData(this.details);
        }
    }
};
__decorate([
    Prop()
], Details.prototype, "filterImgLv", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsType", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsRoute", void 0);
__decorate([
    Prop()
], Details.prototype, "isDetailsLeftBottomProps", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsData", void 0);
__decorate([
    Prop()
], Details.prototype, "offset", void 0);
__decorate([
    Ref()
], Details.prototype, "pictureRef", void 0);
__decorate([
    Ref()
], Details.prototype, "imageScreenRef", void 0);
__decorate([
    Ref()
], Details.prototype, "toolbarRef", void 0);
__decorate([
    Prop()
], Details.prototype, "isChartType", void 0);
__decorate([
    Watch('detailsData', { deep: true })
], Details.prototype, "onDetailsData", null);
__decorate([
    Watch('isDetailsLeftBottomProps', { immediate: true })
], Details.prototype, "oniIDetailsLeftBottom", null);
Details = __decorate([
    Component({
        name: 'Toolbar',
        components: { DetailsLeftToolbar, DetailsLeftPicture, DetailsLeftBottom },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], Details);
export default Details;
